import { toast } from "react-toastify";

export const pushToast = (text, type = "info") => {
  switch (type) {
    case "success":
      toast.success(text);
      break;
    case "error":
      toast.error(text);
      break;
    case "warning":
      toast.warning(text);
      break;
    case "info":
    default:
      toast.info(text);
  }
};
